<template>
    <van-popup position="bottom" v-model="show" :close-on-click-overlay="false" :style="{ height: '40%', width: '100%' }">
        <van-nav-bar :title="title" left-text="取消" right-text="确定" @click-left="cancel" @click-right="confirm" />
        <van-tree-select :items="columns" :active-id.sync="result" :main-active-index.sync="activeIndex" />
    </van-popup>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        columns: {
            type: Array,
            default: [],
        },
        title: {
            type: String,
            default: ''
        },
        multiple: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            result: '',
            activeIndex: 0,
        };
    },
    watch: {
        multiple: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.result = []
                } else {
                    this.result = ''
                }
            }
        }
    },
    methods: {
        confirm() {
            console.log(this.result);
            const resultItem = [];
            this.columns.forEach((item) => {
                item.children.forEach(item2 => {
                    if (this.result.indexOf(item2.id) != -1) {
                        resultItem.push(item2);
                    }
                })

            });
            this.$emit("confirm",resultItem);
        },
        cancel() {
            this.$emit("cancel");
        },
    },
};
</script>
<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/cmscomponents/treeSelect/treeSelect.vue